import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ae526a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "线下报名系统", -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("登录")

import { ref, reactive } from 'vue'
    import {LocationQueryValue, useRouter} from 'vue-router'
    import {POST} from '@/service/index'
    import {ElForm, ElMessage} from 'element-plus'
    import store from "@/store";

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const ruleFormRef = ref<InstanceType<typeof ElForm>>()
    const router = useRouter();

    const validateUsername = (rule: any, value: any, callback: any) => {
        if (value === '') {
            callback(new Error('请输入管理帐号'))
        } else {
            if (ruleForm.username !== '') {
                if (!ruleFormRef.value) return
                ruleFormRef.value.validateField('checkPass', () => null)
            }
            callback()
        }
    }

    const validatePasswrod = (rule: any, value: any, callback: any) => {
        if (value === '') {
            callback(new Error('请输入管理密码'))
        } else {
            callback()
        }
    }

    const ruleForm = reactive({
        username: '',
        password: ''
    })

    const loginHandler = async (username: string | LocationQueryValue[], password: string | LocationQueryValue[] ) => {
        let url = '/api/login?';
        if ( username ) {
            url += `username=${username}`
        }
        if ( password  ) {
            url += `&password=${password}`
        }
        const res:any = await POST(url)
        const { data } = res.data
        if ( data.code == '200' ) {
          store.commit('setUser', data)
          await router.push({
            name: 'Home'
          })
        } else {
          ElMessage.error('登录失败请确认账号及密码！')
        }
    }

    
    const  submitForm = (formEl: InstanceType<typeof ElForm> | undefined) => {
        if (!formEl) return
        formEl.validate(async (valid) => {
            if (valid) {
                let { username, password } = ruleForm
                loginHandler(username, password)
            } else {
                console.log('error submit!')
                return false
            }
        })
    }

    const rules = reactive({
        username: [{ validator: validateUsername, trigger: 'blur' }],
        password: [{ validator: validatePasswrod, trigger: 'blur' }]
    })
    
    

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(ElForm), {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: _unref(ruleForm),
        "status-icon": "",
        rules: _unref(rules),
        "label-width": "100px",
        class: "demo-ruleForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"280px","height":"40px","font-size":"16px"},
                modelValue: _unref(ruleForm).username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(ruleForm).username) = $event)),
                placeholder: "请输入管理帐号",
                type: "text",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "用户密码",
            prop: "username"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                style: {"width":"280px","height":"40px","font-size":"16px"},
                modelValue: _unref(ruleForm).password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(ruleForm).password) = $event)),
                placeholder: "请输入管理密码",
                type: "password",
                autocomplete: "off"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}
}

})